module.exports = __webpack_public_path__ + "static/media/close_blue.c5ffcf47.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/forum/close_blue.svg
// module id = ./src/assets/media/forum/close_blue.svg
// module chunks = 16